import { useSearchParams } from "react-router-dom";
import type { OrganizationScope } from "@core/features/organization";

/**
 * Which organizations the homepage's network graph draws.
 *
 * Every approved one, unless the page's address asks for a narrower set:
 * `?network=staff` for only those staff listed themselves, or
 * `?network=featured` for only the featured ones, so the choices can be
 * looked at side by side. Only the graph follows it; the panel listing the
 * organizations always lists them all.
 */
export function useNetworkScope(): OrganizationScope {
  const [searchParams] = useSearchParams();
  const asked = searchParams.get("network");
  return asked === "staff" || asked === "featured" ? asked : "all";
}

export default useNetworkScope;
